import getItemTrigger from './get-item-trigger';
import getItemAction from './get-item-action';
import getItemClosure from './get-item-closure';
import getFilterCondition from './get-filter-condition';
import getFilter from './get-filter';

/**
 * Returns data about an item
 *
 * @param {String} itemType Whether it's a trigger, action or a closure
 * @param {Number} itemID The item ID
 * @return {Object|undefined} The item
 */
const getItem = ( itemType, itemID ) => {
	// Convert item ID to number
	itemID = parseInt( itemID );

	if ( itemType === 'trigger' ) {
		return getItemTrigger( itemID );
	}

	if ( itemType === 'action' ) {
		return getItemAction( itemID );
	}

	if ( itemType === 'closure' ) {
		return getItemClosure( itemID );
	}

	if ( itemType === 'filter' ) {
		return getFilter( itemID );
	}

	if ( itemType === 'filter-condition' ) {
		return getFilterCondition( itemID );
	}
}

export default getItem;
